import React from 'react';
export var EmptyBlockContent = function EmptyBlockContent(_ref) {
  var children = _ref.children,
      style = _ref.style;
  return React.createElement("div", {
    className: "empty",
    style: style
  }, children);
};
export default EmptyBlockContent;